//@flow
import RequestBuilder from '../../../util/request-builder';
import OVPPlaylistService from '../services/playlist-service';
import OVPConfiguration from '../config';
import VidiunPlaylist from '../response-types/vidiun-playlist';
import VidiunMediaEntries from '../response-types/vidiun-media-entries';

export default class OVPPlaylistLoader implements ILoader {
  _playlistId: string;
  _requests: Array<RequestBuilder>;
  _response: any = {};

  static get id(): string {
    return 'playlist';
  }

  /**
   * @constructor
   * @param {Object} params loader params
   */
  constructor(params: Object) {
    this.requests = this.buildRequests(params);
    this._playlistId = params.playlistId;
  }

  set requests(requests: Array<RequestBuilder>) {
    this._requests = requests;
  }

  get requests(): Array<RequestBuilder> {
    return this._requests;
  }

  set response(response: any) {
    this._response.playlistData = new VidiunPlaylist(response[0].data);
    this._response.playlistItems = new VidiunMediaEntries(response[1].data);
  }

  get response(): any {
    return this._response;
  }

  /**
   * Builds loader requests
   * @function
   * @param {Object} params Requests parameters
   * @returns {RequestBuilder} The request builder
   * @static
   */
  buildRequests(params: Object): Array<RequestBuilder> {
    const config = OVPConfiguration.get();
    const requests: Array<RequestBuilder> = [];
    requests.push(OVPPlaylistService.get(config.serviceUrl, params.vs, params.playlistId));
    requests.push(OVPPlaylistService.execute(config.serviceUrl, params.vs, params.playlistId));
    return requests;
  }

  /**
   * Loader validation function
   * @function
   * @returns {boolean} Is valid
   */
  isValid(): boolean {
    return !!this._playlistId;
  }
}



// WEBPACK FOOTER //
// ./v-provider/ovp/loaders/playlist-loader.js


// WEBPACK FOOTER //
// providers/v-provider/ovp/loaders/playlist-loader.js